import React, { PureComponent } from "react";
import { connect } from "react-redux";
import {
  setCurrentNavPage,
  setSubMenuDirection,
  setSubMenuDirectionToggle,
  initBudgetSettingClient,
  setBudgetSettingClient,
  setBudgetYear
} from "Actions";
import {
  fetchBudget,
  fetchCategoriesSettings,
  fetchBudgetCollaborator,
  fetchCollaboratorSettingSuggestions,
  fetchParameterSettings,
  fetchNonCategorizedTaskTypeCount
} from "Thunks";
import { HORIZONTAL, VERTICAL } from "Config";
import BudgetSettings from "./BudgetSettings";
import { getUrlParams } from "../../utils";
import moment from "moment";

class BudgetSettingsPage extends PureComponent {
  constructor(props) {
    super(props);
    let { uen } = this.props.match.params;

    this.state = { organizationUen: uen };
  }

  componentDidMount() {
    const { dispatch, subMenuDirection, location } = this.props;

    dispatch(setBudgetYear(getUrlParams(location, "year")));
    dispatch(setCurrentNavPage("BUDGET_SETTING"));
    if (subMenuDirection === VERTICAL) {
      dispatch(setSubMenuDirection(HORIZONTAL));
    }
    let id = getUrlParams(location, "id");
    let name = getUrlParams(location, "name");
    dispatch(setSubMenuDirectionToggle(true));
    if (id !== null && name !== undefined) {
      dispatch(initBudgetSettingClient());
      dispatch(setBudgetSettingClient({ id, name }));
      dispatch(fetchBudget());
      dispatch(fetchCategoriesSettings());
      dispatch(fetchCollaboratorSettingSuggestions());
      dispatch(fetchNonCategorizedTaskTypeCount());
      dispatch(fetchBudgetCollaborator());
      dispatch(fetchParameterSettings(moment().year()));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(initBudgetSettingClient());
  }

  render() {
    const { location } = this.props;
    const id = getUrlParams(location, "id");
    const name = getUrlParams(location, "name");
    const year = getUrlParams(location, "year");
    return (
      <div className={`page-content`}>
        <BudgetSettings
          uen={this.state.organizationUen}
          clientId={id}
          clientName={name}
          year={year}
        />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  client: state.budget.setting.client,
  subMenuDirection: state.params.subMenuDirection,
  currentOrganization: state.auth.currentOrganization
});

export default connect(mapStateToProps)(BudgetSettingsPage);



// WEBPACK FOOTER //
// ./src/components/BudgetSettings/BudgetSettingsPage.js